import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { initializeFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Web-App-Konfiguration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAab8imilUfYvc7DToofwtvH82tUlePAQM",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "vetapp-b9c89.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "vetapp-b9c89",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "vetapp-b9c89.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "440725282824",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:440725282824:web:161b320eef2154ffcdf1bd"
};

// Firebase initialisieren
const app = initializeApp(firebaseConfig);

// Services exportieren
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-west1');

// Emulator-Konfiguration für lokale Entwicklung (optional)
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFirestoreEmulator(db, 'localhost', Number(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || 8080));
  connectStorageEmulator(storage, 'localhost', 9199);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export default app;
